"use client";

import dynamic from "next/dynamic";

import type { HomepageHeroImageData } from "@/components/common/HomepageHeroImage/HomepageHeroImage.types";
import { useVariant } from "@/hooks/useVariant";
import { PromoData } from "@/types/promoData";

import HomepageHero from "./HomepageHero";
import type { HomepageHeroData } from "./HomepageHero.types";

type HomepageHeroWrapperProps = {
  data: HomepageHeroData;
  dataA: HomepageHeroImageData;
  dataB: HomepageHeroImageData;
  promoCf?: PromoData;
};

/* A/B is lazy: control always paints first, then VWO may swap. */
const HomepageHeroImage = dynamic(
  () => import("@/components/common/HomepageHeroImage/HomepageHeroImage")
);

const HomepageHeroWrapper = ({ data, dataA, dataB, promoCf }: HomepageHeroWrapperProps) => {
  const variant = useVariant("vwo32349", "control", false);

  if (variant === "a") {
    return (
      <div className="vwo32349-a">
        <HomepageHeroImage data={dataA} promoCf={promoCf} />
      </div>
    );
  }

  if (variant === "b") {
    return (
      <div className="vwo32349-b">
        <HomepageHeroImage data={dataB} promoCf={promoCf} />
      </div>
    );
  }

  return (
    <div className="vwo32349-control">
      <HomepageHero data={data} promoCf={promoCf} />
    </div>
  );
};

export default HomepageHeroWrapper;
